import _ from "lodash";
import React, { useState } from "react";
import classes from "./SelectDateTime.scss";
import ScreenPanel from "../../ScreenPanel";
import moment from "moment";
import { useI18n } from "Hooks";
import { DatePicker, Button } from "@toddle-edu/ds-web";
import { TimePicker } from "../ManageStudentActivity/components";
import { TickCircleFilled } from "@toddle-edu/ds-icons";

const styles = {
  titleTextStyle: { fontSize: "2rem" },
  footerContainerStyle: { height: "96px", boxShadow: "none" },
  containerStyle: { padding: "0 32px" },
  titleContainerStyle: { marginTop: "30px" },
};

const FooterComponent = props => {
  const { onCloseClick, updatePost, date, time, hasError } = props;
  const { t } = useI18n(["common"]);

  const onDoneClick = () => {
    updatePost({
      publishedAt: moment(
        date.format("YYYY-MM-DD") + " " + time.format("HH:mm")
      ).toISOString(),
    });
    onCloseClick();
  };

  const onResetClick = () => {
    updatePost({ publishedAt: undefined });
    onCloseClick();
  };

  return (
    <div className={classes.footerContainer}>
      <Button
        size={"large"}
        onClick={onResetClick}
        variant={"inline-progressive"}
      >
        {t("common:reset")}
      </Button>
      <div className={classes.footerRightContainer}>
        <Button
          size={"large"}
          onClick={onCloseClick}
          variant={"outlined-subtle"}
        >
          {t("common:cancel")}
        </Button>
        <Button
          size={"large"}
          variant={"progressive"}
          onClick={onDoneClick}
          disabled={hasError}
          icon={<TickCircleFilled />}
        >
          {t("common:done")}
        </Button>
      </div>
    </div>
  );
};

const SelectDateTime = ({ screenPanelProps }) => {
  const publishedAt = _.get(screenPanelProps, "postDetails.publishedAt");

  const [date, setDate] = useState(moment(publishedAt));
  const [time, setTime] = useState(moment(publishedAt));
  const [error, setError] = useState("");

  const { t } = useI18n(["common"]);

  const handleTime = (key, value) => {
    if (key === "date") setDate(value);
    else setTime(value);

    const publishedAt = moment(
      key === "time"
        ? date.format("YYYY-MM-DD") + " " + value.format("HH:mm")
        : value.format("YYYY-MM-DD") + " " + time.format("HH:mm")
    );

    if (publishedAt.isAfter(moment()))
      setError("Future time cannot be selected");
    else setError("");
  };

  return (
    <ScreenPanel
      {...screenPanelProps}
      footerComponent={
        <FooterComponent
          {...screenPanelProps}
          date={date}
          time={time}
          hasError={!_.isEmpty(error)}
        />
      }
      titleTextStyle={styles.titleTextStyle}
      footerContainerStyle={styles.footerContainerStyle}
      containerStyle={styles.containerStyle}
      titleContainerStyle={styles.titleContainerStyle}
    >
      <div className={classes.dateTimeContainer}>
        <DatePicker
          picker={"date"}
          label={t("common:select_date")}
          placeholder={"DD/MM/YYYY"}
          size={"large"}
          maxDate={moment()}
          value={date}
          onChange={value => handleTime("date", value)}
        />
        <TimePicker
          label={t("configuration:select_time")}
          placeholder={"00:00 AM"}
          size={"large"}
          value={time}
          onChange={value => handleTime("time", value)}
          timeError={error}
        />
      </div>
    </ScreenPanel>
  );
};

export default SelectDateTime;
